<template>
  <SectionWrapper>
    <div class="sm:p-0 p-2.5">
      <div class="flex flex-col gap-2.5 md:flex-row w-full min-h-100">
        <div
          class="flex-1 rounded-lg bg-black text-white p-5 md:p-20 flex flex-col justify-center items-center text-center"
        >
          <h2 class="text-3xl md:text-5xl font-bold mb-6">
            {{ $t("cta_split.share_title") }}
          </h2>
          <p class="max-w-sm mb-10 text-base leading-relaxed text-gray-300">
            {{ $t("cta_split.share_desc") }}
          </p>

          <button
            @click="store.openNewArtwork"
            class="border border-white sm:px-10 px-5 py-4 rounded-lg cursor-pointer text-base font-bold transition-all hover:bg-white hover:text-black"
          >
            {{ $t("cta_split.share_btn") }}
          </button>
        </div>

        <div
          class="flex-1 rounded-lg bg-primary-blue text-white p-5 md:p-20 flex flex-col justify-center items-center text-center"
        >
          <h2 class="text-3xl md:text-5xl font-bold mb-6">
            {{ $t("cta_split.own_title") }}
          </h2>
          <p class="max-w-sm mb-10 text-base leading-relaxed text-blue-100">
            {{ $t("cta_split.own_desc") }}
          </p>

          <NuxtLink :to="$localePath('/gallery')">
            <button
              class="bg-black text-white sm:px-10 px-5 py-4 rounded-lg cursor-pointer text-base font-bold transition-all hover:-translate-y-1 hover:shadow"
            >
              {{ $t("cta_split.own_btn") }}
            </button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </SectionWrapper>
</template>

<script setup lang="ts">
import SectionWrapper from "./section-wrapper.vue";

const store = useNewArtworkStore();
</script>
